import { Link } from "react-router-dom";
import type { AdminAuditRow } from "../lib/types";
import { formatDate, parseJson } from "../lib/format";
import { EmptyState } from "./States";

/** Compact change summary from the before/after JSON snapshots. */
function changeSummary(row: AdminAuditRow): string | null {
  const before = parseJson<Record<string, unknown>>(row.before_json);
  const after = parseJson<Record<string, unknown>>(row.after_json);
  if (!before && !after) return null;
  if (before?.status && after?.status) return `${before.status} → ${after.status}`;
  if (after) return JSON.stringify(after);
  if (before) return JSON.stringify(before);
  return null;
}

export function AuditTable({
  rows,
  showTenant = true,
}: {
  rows: AdminAuditRow[];
  showTenant?: boolean;
}) {
  if (rows.length === 0) return <EmptyState>No audit entries.</EmptyState>;
  return (
    <table className="data">
      <thead>
        <tr>
          <th>When</th>
          <th>Action</th>
          <th>Actor</th>
          {showTenant ? <th>Tenant</th> : null}
          <th>Change</th>
        </tr>
      </thead>
      <tbody>
        {rows.map((r) => {
          const change = changeSummary(r);
          return (
            <tr key={r.id}>
              <td className="num" style={{ whiteSpace: "nowrap" }}>
                {formatDate(r.created_at)}
              </td>
              <td>
                <span className="pill mono">{r.action}</span>
              </td>
              <td>{r.actor_email ?? <span className="faint">—</span>}</td>
              {showTenant ? (
                <td className="mono">
                  {r.tenant_id ? (
                    <Link to={`/tenants/${r.tenant_id}`}>{r.tenant_id}</Link>
                  ) : (
                    <span className="faint">—</span>
                  )}
                </td>
              ) : null}
              <td className="mono faint">{change ?? "—"}</td>
            </tr>
          );
        })}
      </tbody>
    </table>
  );
}
